import { isEmbarcacaoThrustersEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoThruster,
  EmbarcacaoThrustersState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const THRUSTERS_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoThruster[]> = {
  select: (ficha) => ficha.thrusters,
  isEmpty: isEmbarcacaoThrustersEmpty,
  secao: "os Thrusters",
};

interface UseEmbarcacaoThrustersResult extends EmbarcacaoThrustersState {
  reload: () => void;
}

/** Consulta os thrusters da embarcação pedida. Somente leitura. */
export function useEmbarcacaoThrusters(id: string): UseEmbarcacaoThrustersResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, THRUSTERS_QUERY);

  return { ...state, thrusters: data };
}
